import IValidationError from './IValidationError';

const getFieldErrorMessage = (
  fieldName: string,
  errorMessages: IValidationError[]
): string | undefined => {
  const error = errorMessages.find(
    (errorMessage) => errorMessage.property === fieldName
  );

  return error === undefined ? undefined : error.message;
};

export default getFieldErrorMessage;
